<template>
  <div>
    <div class="product-content" v-if="!loading">
      <el-form size="small" ref="form" :model="form" label-width="150px">
        <!--基础设置-->
        <Basic :form="form" :editType="'edit'"></Basic>

        <!--时间设置-->
        <!-- <Datetime :form="form"></Datetime>
     -->
        <!--其它-->
        <Other :form="form"></Other>
      </el-form>
    </div>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import activityApi from '@/api/activity.js';
import Basic from './part/Basic.vue';
import Datetime from './part/Datetime.vue';
import Other from './part/Other.vue';
export default {
  components: {
    /*基础设置*/
    Basic,
    /*时间设置*/
    Datetime,
    /*其它*/
    Other
  },
  data() {
    return {
      form: {
        /* 房源id */
        activity_id:'',
        /*房源名称*/
        title: '',
        /* 房源封面 */
        imgUrl:[],
        /* 房源副标题 */
        subtitle:'',
        time_bucket:[],//时间段
        iden_num:1,//营员参与最大人数
        refund_type:1,//退款比例
        refund:0,//退款金额
        /* 内容 */
        content:'',
        route:"",//行程
        notice:"",//须知
        /*房源时间*/
        active_time: '',
        /*是否生效，默认1为生效，0为不生效*/
        status: 1,
        /*默认排序*/
        sort: 100,
        /*是否免费*/
        is_free:1,
        /*价格*/
        price:0,
        /*是否需要材料*/
        is_data:0,
        categorya:[],
        label:[],
        setting:{
          house_area:0,//使用面积
          hux:"",
          yzarea:0,//院子面积
          diy:"",//装修
          useYear:"",//使用年限
          phone:"",//联系方式
          name:"",//联系人

        },
        is_commond:0,
        ss:0,
        ss_price:0,
        note:"",
        numb:"",//
        ban:[]
      },
      /*判断是否正在加载*/
      loading: false,
    };
  },
  created() {
    this.form.activity_id = this.$route.query.activity_id;
    this.getData();
  },
  methods: {

    /*获取编辑数据*/
    getData() {
      let self = this;
      self.loading = true;
      activityApi.getActivity(
        {
          activity_id: self.form.activity_id
        },
        true
      )
        .then(res => {

          let tempForm=res.data.detail;
          tempForm.activity_id = self.form.activity_id;
          self.form = tempForm;
       

          self.loading = false;
  
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
        
          let params = self.form;
     
          self.loading = true;
      
          
          activityApi.editActivity(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，修改成功',
                type: 'success'
              });
              self.$router.push('/plus/activity/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/edit.vue